export const DATA_TEST_IDS = {
  starterBannerButton: 'starter-banner-get-started-button',
  upgradeButton: 'upgrade-plan-modal-upgrade-button',
};
